<!--登陆界面 -->
<template>
  <div id="Login">
    <div class="login-container">
      <div class="login-from">
        <div class="logo-header">
          <div class="logo-icon-layer">
            <img src="../assets/images/logo.png" alt />
          </div>
          <div class="title-layer">
            <span class="main">国家铁路局安全技术中心</span>
            <span class="main">中国职业安全健康协会铁道分会</span>
          </div>
        </div>
        <div class="custom-form" @keyup.enter="submitForm('ruleForm')">
          <el-form
            :model="ruleForm"
            :rules="rules"
            ref="ruleForm"
            label-width="0px"
            class="ms-content"
          >
            <el-form-item prop="username">
              <el-input
                placeholder="请输入账号"
                v-model="ruleForm.username"
                prefix-icon="el-icon-user"
                ref="input_name"
                tabindex="1"
                clearable
                @clear="get_focus('input_name')"
              ></el-input>
            </el-form-item>
            <el-form-item prop="password">
              <el-input
                placeholder="请输入密码"
                show-password
                v-model="ruleForm.password"
                prefix-icon="el-icon-lock"
                tabindex="2"
                ref="input_pwd"
                @clear="get_focus('input_pwd')"
                clearable
              ></el-input>
            </el-form-item>
            <div class="login-btn" v-show="LOGINSHOW">
              <el-button type="primary" @click="submitForm('ruleForm')"
                >登 录</el-button
              >
            </div>
            <div class="loading-btn" v-show="LOADINGSHOW">
              <el-button type="primary" disabled>正 在 登 录...</el-button>
            </div>
          </el-form>
        </div>
        <div class="other-login-methods">
          <span>快捷登录方式：</span>
          <img src="../assets/images/wechat.png" alt />
        </div>
      </div>
      <div class="login-banner">
        <img src="../assets/images/banner.png" alt />
      </div>
    </div>
  </div>
</template>

<script>
import { ElMessage } from "element-plus";
import { userLogin } from "@api/login";
import {GetDataSystemConfigList} from "../api/ApiSystemConfig"
import { setUserInfo, setToken,setSystemConfig } from "@/util/authority";

export default {
  data: function () {
    return {
      ruleForm: {
        qddm: "000",
        username: "",
        password: "",
        yzmcode: "",
        resource: false,
      },
      rules: {
        username: [
          { required: true, message: "请输入用户名", trigger: "blur" },
        ],
      },
      LOGINSHOW: true,
      LOADINGSHOW: false,
    };
  },
  methods: {
    get_focus(type) {
      this.$nextTick(() => {
        this.$refs[type].focus();
      });
    },
    //加载系统配置
    async loadSystemConfig(){
      GetDataSystemConfigList({
        queryModel: {
        },
        pageindex: 1,
        PageSize: 1000,
      }).then(function(res){
        setSystemConfig(res.entities);
      })
    },
    submitForm(formName) {
      var _this = this
      if (!this.LOGINSHOW) return;
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.LOGINSHOW = false;
          this.LOADINGSHOW = true;
          var params = {
            userCode: this.ruleForm.username,
            password: this.ruleForm.password,
          };

          userLogin(params)
            .then(({ id, token, userCode, userName, companyId, userPermissions }) => {
              if(userCode.toUpperCase() != "ADMIN") {
                // 菜单权限
                sessionStorage.setItem("userPermissions", JSON.stringify(userPermissions));
                if(userPermissions.length == 0) {
                  ElMessage({
                    message: "当前用户没有菜单权限，请联系管理员进行设置",
                    duration: 1500,
                    type: 'error',
                  })
                  this.LOGINSHOW = true;
                  this.LOADINGSHOW = false;
                }
              }
              sessionStorage.setItem("UserID", this.ruleForm.username);
              let userInfo = {
                UserName: "",
                CodeID: "",
                CompanyId : 1
              };
              userInfo.UserName = userName;
              userInfo.CodeID = userCode;
              userInfo.CompanyId = companyId
              setUserInfo(userInfo); //设置用户信息
              setToken(token); //设置用户信息
              this.$router.push("/");
              this.LOGINSHOW = true;
              this.LOADINGSHOW = false;
              _this.loadSystemConfig();
            })
            .catch(({ code, message, details, validationErrors }) => {
              console.log(message);
              ElMessage({
                message: message,
                duration: 1500,
                type: 'error',
              })
              this.LOGINSHOW = true;
              this.LOADINGSHOW = false;
            });
        } else {
          return false;
        }
      });
    },
    IsAdmin() {
      let strUsers = ["000", "ADMIN"];
      return strUsers.includes(this.ruleForm.username.toUpperCase())
        ? "1"
        : "0";
    },
  },
  components: {},

  mounted() {},
  watch: {},
};
</script>
<style lang="scss" scoped>
#Login {
  height: 100%;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  .login-container {
    display: flex;
    height: 100%;
    overflow: auto;
    align-items: center;
    padding: 0 50px 0 0;
    .login-from {
      .logo-header {
        display: flex;
        margin-bottom: 70px;
        .logo-icon-layer {
          width: 128px;
          height: 128px;
          img {
            width: 100%;
            height: 100%;
          }
        }
        .title-layer {
          display: flex;
          flex-wrap: wrap;
          flex-direction: column;
          width: 580px;
          height: 128px;
          justify-content: center;
          text-align-last: justify;
          .main {
            font-size: 24px;
            font-family: PingFang SC-Semibold, PingFang SC;
            font-weight: 600;
            color: #000000;
            height: 36px;
            line-height: 36px;
            width: 340px;
          }
          .sub {
            font-size: 24px;
            font-family: PingFang SC-Semibold, PingFang SC;
            font-weight: 600;
            color: #1890ff;
            height: 48px;
            line-height: 48px;
          }
        }
      }
      .custom-form {
      }
      .other-login-methods {
        padding-top: 24px;
        display: flex;
        align-items: center;
        font-size: 16px;
        font-family: PingFang SC-Regular, PingFang SC;
        font-weight: 400;
        color: #000000;
        line-height: 24px;
        img {
          width: 28px;
          height: 28px;
          cursor: pointer;
        }
      }
    }
    .login-banner {
      margin-left: 39px;
      img {
        width: 530px;
        height: 530px;
      }
    }
  }
}
@media screen and (max-width: 1440px) {
  .login-container {
    zoom: 0.8;
  }
}
</style>
<style scoped>
#Login .custom-form /deep/ .el-form-item {
  margin-bottom: 36px;
}
#Login .custom-form /deep/ .el-input__icon {
  font-size: 18px;
  line-height: 50px;
  color: #0747a6;
}
.el-input__inner:focus {
  border-color: #c4c4c4;
}
</style>
<style scoped>
.login-wrap {
  overflow: auto;
}
.login_main {
  width: 968px;
  margin: 156px auto 0;
}
.login_logo > em {
  display: inline-block;
  vertical-align: middle;
  width: 172px;
  height: 25px;
  /* background: url("../../assets/baisonLogo.png") no-repeat; */
  background-size: 152px 25px;
  position: relative;
}
.login_logo > em::after {
  position: absolute;
  right: 0;
  top: 1px;
  width: 1px;
  height: 27px;
  content: "";
  background-color: #fff;
}
.login_logo > img {
  display: inline-block;
  vertical-align: middle;
  width: 157px;
  height: 30px;
  margin-left: 20px;
}
.login_info {
  width: 968px;
  height: 544px;
  display: flex;
  margin-top: 20px;
}
.login_info .login_pic {
  width: 576px;
  height: 544px;
  position: relative;
}
.login_pic > img {
  width: 576px;
  height: 544px;
  border-radius: 16px 0 0 16px;
}
.login_pic .login_img {
  width: 576px;
  height: 544px;
}
.login_info .login_form {
  flex: 1;
  background: #fff;
}
.login_pic /deep/ .swp-img {
  border-radius: 16px 0 0 16px;
}
.login_pic .wz_pic {
  position: absolute;
  bottom: 127px;
  left: 48px;
  color: #fff;
  z-index: 20;
  font-size: 36px;
  font-weight: bold;
}
.login_form {
  border-radius: 16px;
}
.login_form > div {
  width: 264px;
  margin: 0 auto;
  height: 544px;
  position: relative;
}
.login_form > div > div {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
}
.login_form > div > div > h2 {
  font-size: 16px;
  font-weight: 500;
  color: #333333;
}
.login_form .login_forminfo {
  margin-top: 20px;
}

.login_forminfo .ms-content /deep/ .el-form-item {
  margin-bottom: 0 !important;
  border-bottom: 1px solid #808695;
  margin-top: 15px;
}
.login_forminfo /deep/ .el-input__inner {
  /* height: 50px;
  line-height: 50px; */
}
.ms-content /deep/ .el-form-item__content {
  font-size: 0;
}
.ms-content /deep/ .el-input {
  display: inline-block;
  vertical-align: middle;
  width: 360px;
  border-radius: 2px;
}
.ms-content .login_account {
  width: 10%;
  height: 32px;
  display: inline-block;
  vertical-align: middle;
  background: url("../assets/account.png") no-repeat;
  background-size: 15px 18px;
  background-position: center left;
  margin-left: 3%;
}
.ms-content .login_password {
  width: 10%;
  height: 32px;
  display: inline-block;
  vertical-align: middle;
  background: url("../assets/password.png") no-repeat;
  background-size: 16px 18px;
  background-position: center left;
  margin-left: 3%;
}
.ms-content /deep/ .el-input__inner {
  color: #999;
  font-size: 14px;
  height: 50px;
  line-height: 50px;
  border-color: #c4c4c4;
  border-radius: 2px;
}
.ms-content .jzmm {
  border-bottom: 0 !important;
  margin-top: 20px;
}
.footer {
  width: 160px;
  margin: 62px auto 0;
  font-size: 12px;
  color: #fff;
  text-align: center;
}
.footer .footer_link > em,
.footer .footer_link > i {
  display: inline-block;
  vertical-align: middle;
  width: 63px;
}
.footer .footer_link > em:hover,
.footer .footer_link > i:hover {
  cursor: pointer;
  text-decoration: underline;
}
.footer .footer_link > em {
  position: relative;
}
.footer .footer_link > em::after {
  position: absolute;
  right: 0;
  top: 2px;
  width: 1px;
  height: 13px;
  content: "";
  background-color: #fff;
}
.footer .footer_des {
  margin-top: 16px;
}

.login-wrap {
  position: relative;
  width: 100%;
  height: 100%;
  /* background:url("../../assets/login-bg.jpg") no-repeat; */
  background-size: cover;
}

.ms-title {
  width: 100%;
  line-height: 50px;
  text-align: center;
  font-size: 20px;
  color: #fff;
  border-bottom: 1px solid #ddd;
}
.ms-login {
  position: absolute;
  left: 50%;
  top: 50%;
  width: 350px;
  margin: -190px 0 0 -175px;
  border-radius: 5px;
  background: rgba(255, 255, 255, 0.3);
  overflow: hidden;
}
/* .ms-content {
    padding: 30px 30px;
  } */
.login-btn,
.loading-btn {
  /* text-align: center; */
  margin-top: 30px;
}
.login-btn button {
  width: 360px;
  height: 50px;
  background: #0747a6;
  background-color: #0747a6;
  /* box-shadow: 0px 12px 19px 2px rgba(25, 137, 250, 0.24); */
  border-radius: 2px;
  color: #fff;
  font-size: 16px;
  font-weight: bold;
}
.loading-btn button {
  width: 360px;
  height: 50px;
  margin-bottom: 10px;
  font-size: 16px;
  box-shadow: 0px 12px 19px 2px rgba(25, 137, 250, 0.24);
  border-radius: 4px;
  font-weight: bold;
  /* background-color: darkgrey;
    border-color: darkgrey; */
}
.login-tips {
  font-size: 12px;
  line-height: 30px;
  color: #fff;
}
.el-input {
  width: 100%;
}
.login-wrap /deep/ .el-checkbox__input.is-checked + .el-checkbox__label {
  color: #999;
}
.login-wrap.newbgc /deep/ .el-input__inner {
  padding: 0;
}
.login-wrap.newbgc /deep/ input:-webkit-autofill {
  background-color: rgba(255, 255, 255, 0.7) !important;
  background-image: none !important;
  color: #000 !important;
  -webkit-box-shadow: 0 0 0px 1000px rgba(255, 255, 255, 1) inset;
}
.login-wrap.newbgc /deep/ .el-checkbox__input.is-checked .el-checkbox__inner,
.login-wrap.newbgc
  /deep/
  .el-checkbox__input.is-indeterminate
  .el-checkbox__inner {
  background-color: #468dce;
  border-color: #468dce;
}
.login-wrap.newbgc /deep/ .el-form.ms-content .el-form-item--mini.el-form-item,
.login-wrap.newbgc
  /deep/
  .el-form.ms-content
  .el-form-item--small.el-form-item {
  margin-bottom: 38px;
}

.login_forminfo .ms-content /deep/ .el-form-item.yzm {
  border-bottom: none;
  margin-top: 24px;
}
.ms-content /deep/ .el-form-item.yzm .el-input {
  text-indent: 10px;
  width: 136px;
  border: 1px solid #888;
  border-radius: 4px;
  vertical-align: top;
}
.yzm .tpyzcode {
  width: 110px;
  height: 34px;
  margin-left: 14px;
  display: inline-block;
  vertical-align: top;
}
.yzm .tpyzcode:hover {
  cursor: pointer;
}

.login-wrap.newbgc .window_login {
  width: 480px;
  height: 680px;
  background-color: rgba(255, 255, 255, 0.9);
  position: absolute;
  top: 45%;
  right: 8%;
  transform: translate(0, -45%);
}

.login-wrap.newbgc .window_login .title_logo {
  padding-top: 100px;
  padding-bottom: 80px;
  text-align: center;
}
.login-wrap.newbgc .window_login .title_logo .log_img {
  width: 290px;
  height: 48px;
}

.login-wrap.newbgc /deep/ .el-input__inner {
  border: none;
  border-radius: 0;
  background-color: transparent;
}
.login-wrap.newbgc label {
  font-size: 14px;
  color: #999;
}
.login-wrap.newbgc .el-form.ms-content {
  padding-top: 0 !important;
}
.login-wrap .logoBgPicUrl {
  width: 100%;
  height: 100%;
}
::-ms-clear,
::-ms-reveal {
  display: none;
}
</style>


